import type { ReactNode } from 'react';

export const symbol_sound_detection_glass_break: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M180-120q-24.75 0-42.37-17.63Q120-155.25 120-180v-600q0-24.75 17.63-42.38Q155.25-840 180-840h600q24.75 0 42.38 17.62Q840-804.75 840-780v600q0 24.75-17.62 42.37Q804.75-120 780-120H180Zm199.35-417q10.65 0 22.08 4.5Q412.86-528 422-519l116 116 242-271v-106H180v418l157-157q9.07-9 20.04-13.5Q368-537 379.35-537Zm158.24 194q-10.94 0-21.89-4.3-10.94-4.31-19.7-13.7L380-477 180-276v96h600v-404L583-363q-9 10-21 15t-24.41 5Z"
		/>
	</svg>
);
